import React, { useCallback,useEffect, useState } from "react";
import debounce from "lodash.debounce";

import {
  Flex,
  Popover,
  PopoverContent,
  PopoverControl,
  PopoverProps,
} from "@catchoftheday/cg-components";

export type HeaderTileRenderProps = (props: {
  isOpen: boolean;
}) => React.ReactNode;

export type HeaderTileProps = {
  popoverProps?: PopoverProps;
  icon: React.ReactNode | HeaderTileRenderProps;
  children: React.ReactNode;
  onTileShow?: (show: boolean) => void;
};

export const HeaderTile: React.FC<HeaderTileProps> = ({
  popoverProps,
  icon: Icon,
  children,
  onTileShow,
}) => {
  const [tileOpen, setTileOpen] = useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetTileOpen = useCallback(debounce(setTileOpen, 50), []);

  function onMouseLeaveHander() {
    debouncedSetTileOpen.cancel();
    debouncedSetTileOpen(false);
  }

  function onMouseEnterHandler() {
    debouncedSetTileOpen.cancel();
    setTileOpen(true);
  }

  useEffect(() => {
    if (typeof onTileShow == "function") {
      onTileShow(tileOpen);
    }
  }, [tileOpen, onTileShow]);

  return (
    <Popover
      isOpen={tileOpen}
      hideArrow
      hideOnClickOutside
      flexGrow={1}
      zIndex={2}
      {...popoverProps}
    >
      <PopoverControl>
        {({ ref }) => (
          <Flex
            height="100%"
            ref={ref}
            onFocus={onMouseEnterHandler}
            onBlur={onMouseLeaveHander}
            onMouseLeave={onMouseLeaveHander}
            onMouseEnter={onMouseEnterHandler}
          >
            {typeof Icon === "function" ? Icon({ isOpen: tileOpen }) : Icon}
          </Flex>
        )}
      </PopoverControl>
      <PopoverContent>
        <Flex
          role="dialog"
          aria-modal="true"
          onFocus={onMouseEnterHandler}
          onBlur={onMouseLeaveHander}
          onMouseLeave={onMouseLeaveHander}
          onMouseEnter={onMouseEnterHandler}
        >
          {children}
        </Flex>
      </PopoverContent>
    </Popover>
  );
};
